import {cascade} from "@Common/utils/cascade";

import {createSetCredits} from "../common/create-set-credits";

const itemAttr = "adbudget";

export const setAdBudgets = createSetCredits({
    cartAttr: "adBudgets",
    collectCredits: (cart, data) =>
        cascade(cart.items, `[*].billingAvailable.${itemAttr}[*]`, (adBudget, {}, {0:item}) => {
            return ({
                billingId: adBudget.id,
                amount: adBudget.amountAvailable,
                itemId: item.itemId,
                ...data,
                // comments: data.comments
            });
        })
    ,
});

